<div id="mapViewDiv">
  <div class="wrap-logo">
    <a href="https://spatialdecisions.com/" class="logo">
      <img src="{{ logo }}" alt="">
    </a>
    <a href="https://spatialdecisions.com/dibrugarh" class="about">
      <i class="fas fa-info-circle"></i>
      <span>About Project</span>
    </a>
  </div>
</div>
